.splash-screen_splashScreen__r8h5gt0 {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--base-background__1qu8za20);
}
.splash-screen_splashScreenLogo__r8h5gt1 {
  color: var(--button-inverted-foreground__1qu8za21a);
  width: 122px;
}
@media screen and (min-width: 1024px) {
  .splash-screen_splashScreenLogo__r8h5gt1 {
    width: 142px;
  }
}